var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessImagePreRequisite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 126,
    viewBox: "0 0 127 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.867188,
    y: 0.369141,
    width: 125.263,
    height: 125.263,
    rx: 62.6316,
    fill: "#D0FBDF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.4984 99.8424C58.4019 99.8424 53.6124 98.8753 49.1299 96.9411C44.6475 95.0069 40.7484 92.3819 37.4326 89.0661C34.1168 85.7503 31.4918 81.8512 29.5576 77.3687C27.6234 72.8863 26.6562 68.0968 26.6562 63.0003C26.6562 57.9038 27.6234 53.1143 29.5576 48.6319C31.4918 44.1494 34.1168 40.2503 37.4326 36.9345C40.7484 33.6187 44.6475 30.9937 49.1299 29.0595C53.6124 27.1253 58.4019 26.1582 63.4984 26.1582C67.4896 26.1582 71.2659 26.7415 74.8273 27.9082C78.3887 29.0749 81.6738 30.7021 84.6826 32.7898L79.3405 38.224C77.0071 36.7503 74.5203 35.599 71.8799 34.77C69.2396 33.9411 66.4457 33.5266 63.4984 33.5266C55.3317 33.5266 48.3777 36.3972 42.6365 42.1385C36.8953 47.8797 34.0247 54.8336 34.0247 63.0003C34.0247 71.167 36.8953 78.1209 42.6365 83.8622C48.3777 89.6034 55.3317 92.474 63.4984 92.474C71.665 92.474 78.619 89.6034 84.3602 83.8622C90.1014 78.1209 92.972 71.167 92.972 63.0003C92.972 61.895 92.9106 60.7898 92.7878 59.6845C92.665 58.5793 92.4808 57.5047 92.2352 56.4608L98.222 50.474C98.8975 52.4389 99.4194 54.4652 99.7878 56.5529C100.156 58.6407 100.34 60.7898 100.34 63.0003C100.34 68.0968 99.3734 72.8863 97.4391 77.3687C95.5049 81.8512 92.8799 85.7503 89.5641 89.0661C86.2484 92.3819 82.3492 95.0069 77.8668 96.9411C73.3843 98.8753 68.5948 99.8424 63.4984 99.8424ZM58.3405 79.9477L42.6826 64.2898L47.8405 59.1319L58.3405 69.6319L95.1826 32.6977L100.34 37.8556L58.3405 79.9477Z",
    fill: "#1D874C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessImagePreRequisite);
export default __webpack_public_path__ + "static/media/SuccessImagePreRequisite.0fcf1eaeed5069b04e60bb41bfcfd196.svg";
export { ForwardRef as ReactComponent };